'use client'

// @ts-ignore
import { Splide, SplideSlide } from '@splidejs/react-splide'
// @ts-ignore
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll'
// @ts-ignore
import '@splidejs/react-splide/css/core'
import { ImageWithFallback } from '@/components/atoms/ImageWithFallback'
import { SliderBannerDataType } from '@/interfaces/pages'
import './styles.scss'

type SliderBannerProps = {
  banners: SliderBannerDataType['banners']
}

export const SliderClients = ({ banners }: SliderBannerProps) => {
  return (
    <section className="slider-clients-section">
      <div className="slider-clients-title">
        <h2>Nossos clientes</h2>
      </div>
      <Splide
        aria-label="Our clients"
        options={{
          type: 'loop',
          arrows: false,
          pagination: false,
          perPage: 5,
          breakpoints: {
            825: {
              perPage: 3,
            },
          },
          gap: '1rem',
          width: '100%',
          drag: 'free',
          autoScroll: {
            speed: 0.3,
            pauseOnHover: true,
            pauseOnFocus: false,
          },
        }}
        extensions={{ AutoScroll }}
      >
        {banners.map((banner) => (
          <SplideSlide key={banner.url}>
            <div className="slider-clients-container ">
              <ImageWithFallback
                src={banner.url}
                alt={banner.alternativeText}
                loading="lazy"
                fill
                sizes="(max-width: 768px) 20vw, 10vw"
                data-splide-lazy={banner.url}
              />
            </div>
          </SplideSlide>
        ))}
      </Splide>
    </section>
  )
}
